import { z } from 'zod'
import noLeadingSpaces from '../../../utilities/noLeadingSpaces'

export const roleSwitchSchema = z.object({
  name: z.string().min(1, 'Name is required').max(50),

  email: z
    .string()
    .min(5, { message: 'Required' })
    .superRefine((value, ctx) => {
      if (value !== '') {
        if (!/^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Invalid email format.',
          })
        }
      }
    })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),

  mobile: z
    .string()
    .nullable()
    .transform((value) => (value === null ? '' : value))
    .refine(
      (value) => {
        return (
          (/^\d{10}$/.test(value) &&
            parseInt(value, 10) !== 0 &&
            !/\+/.test(value)) ||
          value === ''
        )
      },
      {
        message: 'Enter a Valid 10-digit Mobile Number',
      }
    ),

  role_name: z
    .string({ invalid_type_error: 'Required.' })
    .min(1, { message: 'Required.' }),

  role: z.any(),

  district: z.string().min(1, { message: 'Required.' }),
  district_id: z.any().optional(),
  whatsapp_no: z
    .string()
    .nullable()
    .optional()
    .transform((value) => value ?? '')
    .refine(
      (value) =>
        value === '' ||
        (/^\d{10}$/.test(value) &&
          parseInt(value, 10) !== 0 &&
          !/\+/.test(value)),
      { message: 'Enter a Valid 10-digit Mobile Number' }
    ),

  whatsapp_choice: z
    .string()
    .nonempty('Please select whether this is your WhatsApp number'),
})

export type RoleSwitchSchema = z.infer<typeof roleSwitchSchema>
